import { Pill } from "../../../components/pill";
import { TableComponent } from "../../../components/table";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import { MonthlyEventsSummary } from "../../../redux/features/admin/event/events.types";
import { currencyShorts, eventStatusPillMap } from "../../../utils/constants";
import { formatToCurrency } from "../../../utils/helpers";
import { QueryParams } from "../../../utils/types";

export const MonthlyEvents = ({
  eventsData,
  monthlyQuery,
  setMonthlyQuery,
  fetchingEvents,
}: {
  eventsData: MonthlyEventsSummary;
  monthlyQuery: QueryParams;
  setMonthlyQuery: (monthlyQuery: QueryParams) => void;
  fetchingEvents: boolean;
}) => {
  return (
    <BgWrapper className="mt-[2px] flex w-full flex-col gap-3 !rounded-t-none">
      <TableComponent
        headers={[]}
        rows={
          eventsData?.data?.data?.map((event, idx) => {
            return {
              id: idx,
              items: [
                <div
                  className={`flex w-full flex-1 flex-col gap-2 md:flex-row md:items-center`}
                >
                  <img
                    src={event.image}
                    alt="event banner"
                    className="block h-[40px] w-[40px] overflow-hidden rounded-sm object-cover"
                  />

                  <p className="flex flex-1 flex-wrap items-center gap-[4px] text-sm text-grey-600">
                    <span className="font-bold text-grey-900">
                      {event.name}{" "}
                    </span>
                    <span>
                      {event?.currency === "Canadian Dollars" ? " 🇨🇦 " : " 🇳🇬 "}
                      ∙
                    </span>
                    <span>
                      {event.ticketsSold || "No"} Ticket
                      {event.ticketsSold > 1 ? "s" : ""} Sold
                    </span>
                    <span>
                      {event?.amount > 0
                        ? `(${formatToCurrency(event?.amount, {
                            currency: event?.currency
                              ? currencyShorts[event.currency]
                              : "NGN",
                          })}) Paid`
                        : "∙ FREE"}
                    </span>
                  </p>
                  <div className="flex flex-row flex-wrap items-center gap-2">
                    <Pill
                      className=""
                      text={eventStatusPillMap[event?.status!]?.text}
                      variation={
                        event.status === "completed"
                          ? "grey"
                          : eventStatusPillMap[event?.status!]?.variant
                      }
                    />
                  </div>
                </div>,
              ],
            };
          }) ?? []
        }
        loadingRows={monthlyQuery.limit}
        isLoading={fetchingEvents}
        isTableEmpty={[0, undefined].includes(eventsData?.data?.data?.length)}
        emptyTitle="No Events"
        emptySubTitle=""
        emptyImage="/assets/images/calendar-3d.png"
        currentPage={monthlyQuery.page ?? 1}
        totalCount={eventsData?.data?.totalCount ?? 0}
        itemsPerPage={monthlyQuery.limit!}
        isPaginated
        pageRangeDisplayed={3}
        onPageChange={(page) => {
          setMonthlyQuery({
            ...monthlyQuery,
            page: page,
          });
        }}
        className="mt-3"
      />
    </BgWrapper>
  );
};
